<template>
    <div>
        <v-form
            lazy-validation
            ref="form"
        >
        <table>
            <tr>
                <th colspan="2" rowspan="2">Тип АРМ</th>
                <th rowspan="2">Всего, шт.</th>
                <th colspan="2">АРМ отечественного производства</th>
                <th colspan="2">АРМ иностранного производства</th>
            </tr>
            <tr>
                <th>Количество АРМ, шт.</th>
                <th>Наименование производителя АРМ</th>
                <th>Количество АРМ, шт.</th>
                <th>Наименование производителя АРМ</th>
            </tr>
            <tr>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
            </tr>
            <tr>
                <td><p>1.1.</p></td>
                <td><p>2</p></td>
                <td>
                    <p>
                    {{1*dataReport.dict2.row_1_4 + 1*dataReport.dict2.row_2_4 + 1*dataReport.dict2.row_3_4 + 1*dataReport.dict2.row_4_4
                    + 1*dataReport.dict2.row_1_6 + 1*dataReport.dict2.row_2_6 + 1*dataReport.dict2.row_3_6 + 1*dataReport.dict2.row_4_6}}
                    </p>
                </td>
                <td>
                    <p>
                        {{1*dataReport.dict2.row_1_4 + 1*dataReport.dict2.row_2_4 + 1*dataReport.dict2.row_3_4 + 1*dataReport.dict2.row_4_4}}
                    </p>
                </td>
                <td><v-combobox v-model="row_0_5" multiple chips :disabled="true"></v-combobox></td>
                <td>
                    <p>
                        {{1*dataReport.dict2.row_1_6 + 1*dataReport.dict2.row_2_6 + 1*dataReport.dict2.row_3_6 + 1*dataReport.dict2.row_4_6}}
                    </p>
                </td>
                <td><v-combobox v-model="row_0_7" multiple chips :disabled="true"></v-combobox></td>
            </tr>
            <tr>
                <td></td>
                <td colspan="6">из них:</td>
            </tr>
            <tr>
                <td><p>1.1.1.</p></td>
                <td><p>Тип 1 - персональные АРМ, находящиеся в собственности*</p></td>
                <td><p>{{1*dataReport.dict2.row_1_4 + 1*dataReport.dict2.row_1_6}}</p></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_1_4"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_1_5" multiple chips :disabled="disableReport"></v-combobox></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_1_6"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_1_7" multiple chips :disabled="disableReport"></v-combobox></td>
            </tr>
            <tr>
                <td><p>1.1.2.</p></td>
                <td><p>Тип 2 - персональные АРМ в аренде</p></td>
                <td><p>{{1*dataReport.dict2.row_2_4 + 1*dataReport.dict2.row_2_6}}</p></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_2_4"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_2_5" multiple chips :disabled="disableReport"></v-combobox></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_2_6"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_2_7" multiple chips :disabled="disableReport"></v-combobox></td>
            </tr>
            <tr>
                <td><p>1.1.3.</p></td>
                <td>
                    <p>
                        Тип 3 - совместно используемые АРМ
                        (рабочие места в переговорных комнатах,
                        залах конференций и т.п.)
                    </p>
                </td>
                <td><p>{{1*dataReport.dict2.row_3_4 + 1*dataReport.dict2.row_3_6}}</p></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_3_4"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_3_5" multiple chips :disabled="disableReport"></v-combobox></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_3_6"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_3_7" multiple chips :disabled="disableReport"></v-combobox></td>
            </tr>
            <tr>
                <td><p>1.1.4.</p></td>
                <td><p>Тип 4 - АРМ, реализованные по технологии "тонкий клиент" (VDI)</p></td>
                <td><p>{{1*dataReport.dict2.row_4_4 + 1*dataReport.dict2.row_4_6}}</p></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_4_4"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_4_5" multiple chips :disabled="disableReport"></v-combobox></td>
                <td><v-text-field :disabled="disableReport" :rules="[rules.numeric]" type="number" v-model.trim="dataReport.dict2.row_4_6"/></td>
                <td><v-combobox v-model="dataReport.dict2.row_4_7" multiple chips :disabled="disableReport"></v-combobox></td>
            </tr>
        </table>
        <v-card-actions
                v-if="this.$route.params.report_id !== 'new'"
        >
            <v-spacer></v-spacer>
            <v-btn
                    @click.native="get_report('get_report_it_001', 'Отчет.xlsx')">Отчет
            </v-btn>
        </v-card-actions>
        </v-form>
    </div>
</template>

<script>
export default {
  name: 'it001',
  props: {
    dataReport: {
      type: Object,
      default: function () {
        return { dict2: {} }
      }
    },
    disableReport: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  data () {
    return {
      rules: {
        numeric: v => v === null || /^([0-9]{0,5})$/.test(v) || 'Должно быть целое неотрицательное число'
      }
    }
  },
  computed: {
    row_0_5 () {
      let all = []
      try {
        all = [...new Set([...this.dataReport.dict2.row_1_5, ...this.dataReport.dict2.row_2_5, ...this.dataReport.dict2.row_3_5, ...this.dataReport.dict2.row_4_5])]
      } catch (e) {
      }
      return all
    },
    row_0_7 () {
      let all = []
      try {
        all = [...new Set([...this.dataReport.dict2.row_1_7, ...this.dataReport.dict2.row_2_7, ...this.dataReport.dict2.row_3_7, ...this.dataReport.dict2.row_4_7])]
      } catch (e) {
      }
      return all
    }
  },
  methods: {
    get_report (urlFile, filename) {
      this.$store.dispatch('reportingReport/downloadFile',
        { id: this.$route.params.report_id, urlFile, filename })
    }
  }
}
</script>

<style scoped>
    table, td, th {
        /*text-align: left;*/
        /*padding: 1px;*/
        border: solid black 1px;
        border-collapse: collapse;
    }
    th {
        vertical-align: top;
        /*text-align: center;*/
    }
    td {
        vertical-align: bottom;
    }
    .td_sum {
        padding-bottom: 27px;
        font-weight: bold;
    }
    .bloc_inline
    {
        display:inline-block;
    }
    .bloc
    {
        border: 1px solid gray
    }

</style>
